import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox } from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTable from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import DatePickerFieldNew from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../../common/components/FormFields/InputField";
import RadioField from "../../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import { fetchUserActionsByMenuId } from "../../../../commonServices/functionalityServices/FunctionalityServices";
import {
  getLastPurchaseDetails,
  postGrnItems,
} from "../../../services/commonServices/grnService/GrnServices";
import { getSupplierList } from "../../../services/generalStore/workOrderServices/WorkOrderServices";
import ItemDetailsTable from "./ItemDetailsTable";
import StoreGRNModal from "./StoreGRNModal";
import GRNListModal from "./GRNListModal";
import {
  AddCircleRounded,
  RemoveCircleOutlineRounded,
} from "@mui/icons-material";

const grnType = [
  {
    id: "dailyOrders",
    value: "dailyOrders",
    label: "Daily Orders",
  },
  {
    id: "dc",
    value: "dc",
    label: "D.C.",
  },
];

const paymentType = [
  {
    id: "credit",
    value: "credit",
    label: "Credit",
  },
  {
    id: "cash",
    value: "cash",
    label: "Cash",
  },
];

const discTaxObj = [
  {
    id: "Before Disc & Tax",
    value: "Before Disc & Tax",
    label: "Before Disc & Tax",
  },
  {
    id: "After Disc & Tax",
    value: "After Disc & Tax",
    label: "After Disc & Tax",
  },
];

const roundingTypes = [
  {
    id: "-",
    label: "-",
    value: "-",
  },
  {
    id: "+",
    label: "+",
    value: "+",
  },
];

const StroeGRN = () => {
  //schema
  const schema = yup.object().shape({
    supplierName: yup
      .object()
      .required("Required")
      .nullable()
      .shape({
        value: yup.string().required("Required"),
        label: yup.string().required("Required"),
      }),
    invoiceNo: yup.string().required("Required"),
    received: yup
      .string()
      .required("Required")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed"),
    gateEntryNo: yup.number().required("Required"),
    // grnBatchCode: yup.array().of(
    //   yup.object().shape({
    //     batchCode: yup.string().required("Required"),
    //   })
    // ),
  });

  const defaultValues = {
    grnType: "dailyOrders",
    grnBatchCode: [{ batchCode: "", expiryDate: new Date() }],
    paymentType: "credit",
    store: "",
    discTax: "After Disc & Tax",
    netPayAmount: "0",
    totalAmount: "0",
    lastDiscAmt: "0",
    invoiceNo: "",
    dcNumber: "",
    gateEntryNo: "",
    supplierName: null,
    grnNumber: "",
    lur: "0",
    ptr: "0",
    gstAmount: "0",
    discAmount: "0",
    mrp: "0",
    batchNumber: "",
    freeQuantity: "0",
    creditNote: "",
    received: "",
    remarks: "",
    otherCharges: "",
    invoiceDate: new Date(),
    dueDate: new Date(),
    lastPurDate: new Date(),
    roundingType: "",
    roundingAmount: 0,
    schDisc: "0",
  };

  const methods = useForm({
    shouldFocusError: false,
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues,
  });
  const {
    control,
    setValue,
    watch,
    getValues,
    reset,
    handleSubmit,
    register,
    formState: { errors },
  } = methods;

  const [dailyOrderDetailsData, setDailyOrderDetailsData] = useState([]); // for daily order details
  const [selectedRow, setSelectedRow] = useState([]); // selected items push into items Details table
  const [selectedRowDetails, setSelectedRowDetails] = useState(null); // last pur details
  const [supplierList, setSupplierList] = useState([]);
  const [supplierValue, setSupplierValue] = useState(null);
  const [totalCalculations, setTotalCalculations] = useState(null);
  const [finalData, setFinalData] = useState(null); // post obj
  const [dailyOrderObj, setDailyOrderObj] = useState(); //  get selected po item
  const [openPost, setOpenPost] = useState(false);
  const [isBatchRequired, setIsBatchRequired] = useState(false);
  const [privilege, setPrivilege] = useState("");
  const [userActions, setUserActions] = useState([]);
  const [resetIndex, setResetIndex] = useState(-1);
  const [dataComingFrom, setDataComingFrom] = React.useState("dailyOrders");
  const [roundingValue, setRoundingValue] = React.useState(null);
  const [selectedGrn, setSelectedGrn] = React.useState(null);

  // backdrop
  const [openBackdrop, setOpenBackdrop] = useState(false);

  // grn modal
  const [openGrnModal, setOpenGrnModal] = useState(false);
  const [openGRNListModal, setOpenGRNListModal] = useState(false);
  const [GRNListPrivilege, setGRNListPrivilege] = useState(null);
  const [isGRNEdit, setIsGRNEdit] = useState(false);
  const [positiveRounding, setPositiveRounding] = React.useState(0);
  const [negativeRounding, setNegativeRounding] = React.useState(0);
  const [selectedRounding, setSelectedRounding] = React.useState("");
  const [finalRounding, setFinalRounding] = React.useState(0);
  const [updateCount, setUpdateCount] = React.useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  let discountType = watch("discTax");
  let getGrnType = watch("grnType");
  let gateEntryNo = watch("gateEntryNo");
  let roundingTypeWatch = watch("roundingType");
  let roundingAmount = watch("roundingAmount");

  React.useEffect(() => {
    if (selectedGrn !== null) {
      setValue("received", selectedGrn?.ReceivedBy);
      setValue("remarks", selectedGrn?.Remark);
    }
  }, [selectedGrn]);

  let invoiceNo = watch("invoiceNo");
  let token = JSON.parse(localStorage.getItem("userInfo"));
  let storeId = token.storeId;
  let paymentMode = watch("paymentType");
  let payment;

  const OpenStoreGRNModal = () => {
    setUpdateCount(0);
    setOpenGrnModal(true);
  };

  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
      setOpenBackdrop(false);
    }
  };

  const handleChangeGetSupplierList = (autoSearchString) => {
    if (autoSearchString !== "") {
      getSupplierList(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          setSupplierList(res.result);
        });
    }
  };

  // set value from input fields

  function postGrnItem(obj) {
    postGrnItems(obj)
      .then((response) => response.data)
      .then((res) => {
        if (res?.statusCode === 400) {
          warningAlert(res?.message);
          setOpenBackdrop(false);
        } else {
          successAlert(res.message);
          setFinalData(null);
          setSelectedRow([]);
          setSelectedRowDetails(null);
          setTotalCalculations(null);
          setDailyOrderDetailsData([]);
          setSupplierList([]);
          setSupplierValue(null);
          setDailyOrderObj();
          setIsBatchRequired(false);
          setOpenBackdrop(false);
          setValue("totalAmt", "");
          setValue("discAmt", "");
          setValue("gstAmt", "");
          setValue("roundingAmt", "");
          setValue("netPaybaleAmt", "");
          setValue("supplierName", null);
          reset(defaultValues);
          setIsGRNEdit(false);
          setSelectedGrn(null);
          setPositiveRounding(0);
          setNegativeRounding(0);
        }
      })
      .catch((error) => {
        errorAlert(error.response.data.message || error.message);
        setOpenBackdrop(false);
        handleClosePost();
      });
  }

  function addRecord() {
    setOpenPost(false);
    setOpenBackdrop(true);
    postGrnItem(finalData);
  }

  if (paymentMode === "credit") {
    payment = 0;
  } else if (paymentMode === "cash") {
    payment = 1;
  }

  const onSubmitDataHandler = (dataObj) => {
    console.log("dataObj321", dataObj);

    let selectedInvoiceDate = watch("invoiceDate");
    let selectedDueDate = watch("dueDate");
    // BatchesRequired
    let requiredArr = [];
    for (let obj of selectedRow) {
      let tempObj = {};
      let batchExpiryDate = new Date(obj.expiryDate);
      tempObj.acceptQty = Number(obj.FreeQty) + Number(obj.DOQty);
      tempObj.batchCode = obj.batchCode;
      tempObj.batchExpiryDate =
        obj.expiryDate !== ""
          ? format(batchExpiryDate, "yyyy-MM-dd'T'hh:mm:ss.000'Z'")
          : format(new Date(), "yyyy-MM-dd'T'hh:mm:ss.000'Z'").slice(0, -2);
      tempObj.conversion = obj.Conversion;
      tempObj.BatchesRequired = obj.BatchesRequired;
      tempObj.dcId = 0;
      tempObj.dcQty = 0;
      tempObj.discAmount = Number(obj.DiscAmt);
      tempObj.schemeDiscount = Number(obj?.SchemeDiscount);
      tempObj.schemeAmount = Number(obj?.SchemeAmount);
      tempObj.discountPer = obj.DiscPer;
      tempObj.freeQty = obj.FreeQty;
      tempObj.isConsignment = obj.Consignment === true ? true : false;
      tempObj.itemId = obj.ItemId;
      tempObj.landedNetRate = Number(obj.landedRate);
      tempObj.mrp = Number(obj.MRP);
      tempObj.netAmount = Number(obj.NetAmount);
      tempObj.octroiAmt = 0;
      tempObj.octroiPer = 0;
      tempObj.otherTaxAmount = obj.otherCharges;
      tempObj.poId = obj.DOId !== null ? obj.DOId : 0;
      tempObj.poQty = obj.DOQty;
      tempObj.purchaseRate = obj.Rate;
      tempObj.rectQty = obj.recQty === undefined ? obj?.PendQty : obj.recQty;
      tempObj.remarks = "";
      tempObj.schemeDiscAmt = 0;
      tempObj.schemePer = 0;
      tempObj.specifications = "";
      tempObj.taxAmount = 0;
      tempObj.totalAmount = Number(obj.Amount);
      tempObj.totalReturnQty = 0;
      tempObj.totalUsedQty = 0;
      tempObj.unitPurchaseRate = obj.Rate;
      tempObj.vatAmount = Number(obj.VATAmt);
      tempObj.vatPercentage = obj.VATPer;
      tempObj.grnId = obj?.GRNId ? obj?.GRNId : null;
      tempObj.grnDetailId = obj?.GRNDetailId ? obj?.GRNDetailId : null;
      tempObj.doDetailId = obj?.DODetailId ? obj?.DODetailId : null;
      requiredArr.push(tempObj);
    }

    for (let i = 0; i < selectedRow.length; i++) {
      if (requiredArr[i].BatchesRequired === true) {
        if (
          selectedRow[i].batchCode === "" ||
          selectedRow[i].batchCode === " " ||
          selectedRow[i].batchCode === null
        ) {
          selectedRow[i].requiredBatchNumber = "#D11A2A";
        }
      }
    }

    console.log("requiredArr321", requiredArr);

    for (let i = 0; i < requiredArr.length; i++) {
      if (
        requiredArr?.some(
          (val) => val?.BatchesRequired === true && val?.batchCode === "",
        )
        // requiredArr[i].BatchesRequired === true &&
        // (requiredArr[i].batchCode === "" ||
        //   requiredArr[i].batchCode === " " ||
        //   requiredArr[i].batchCode === null)
      ) {
        setOpenPost(false);
        setOpenBackdrop(false);
        warningAlert("Please Enter Batch Number!");
      } else if (selectedRow.length > 0) {
        const batchExpiryDate = new Date(requiredArr[i].batchExpiryDate);
        let newDateIS = new Date();
        newDateIS.setHours(0, 0, 0, 0);
        if (Number(requiredArr[i].rectQty) > Number(requiredArr[i].poQty)) {
          setOpenPost(false);
          setOpenBackdrop(false);
          warningAlert("Received Quantity Is Not Valid...!");
        } else if (
          requiredArr[i].BatchesRequired === true &&
          batchExpiryDate < newDateIS
        ) {
          setOpenPost(false);
          setOpenBackdrop(false);
          warningAlert("Select Valid Expiry Date...!");
        } else {
          let postedObj = {
            grnId: selectedGrn?.GRNId > 0 ? selectedGrn?.GRNId : null,
            menuId: location?.state?.menuId,
            privilege: privilege,
            addedBy: token.userId,
            amountPaid: 0,
            appByAccount: 0,
            appByCfo: 0,
            appByPurchase: 0,
            approvedAmount: Number(dataObj?.netPayAmount)
              ? Number(dataObj?.netPayAmount)
              : 0,
            cashCredit: payment,
            computerName: "",
            consignmentGrnId: 0,
            creditNoteAmount: 0,
            dcDate: format(selectedDueDate, "yyyy-MM-dd'T'hh:mm:ss.000'Z'"), // dcDate date change
            debitNoteAmount: 0,
            doId: dailyOrderObj?.DOId,
            dueDate: format(selectedDueDate, "yyyy-MM-dd'T'hh:mm:ss.000'Z'"),
            gateEntryNo: Number(gateEntryNo),
            grnDetailsDto: requiredArr,
            grnDiscountAmount: Number(dataObj.discAmount),
            invoiceDate: format(
              selectedInvoiceDate,
              "yyyy-MM-dd'T'hh:mm:ss.000'Z'",
            ),
            invoiceNo: invoiceNo,
            isApproved: true,
            isApprovedByAcc: true,
            isCancelled: true,
            isClosed: true,
            isConsignment: true,
            isConverted: true,
            isDirectPurchase: true,
            isSettled: true,
            narration: "",
            octroi: 0,
            printFlag: true,
            purchaseReturnAmount: 0,
            receivedBy: dataObj?.received,
            rejByAccount: 0,
            rejByCeo: 0,
            rejByCfo: 0,
            rejByPurchase: 0,
            remark: dataObj.remarks,
            rounding: Number(finalRounding),
            serviceTaxAmt: 0,
            storeId: storeId,
            supplierId: dataObj.supplierName.id,
            totalAmount: Number(dataObj.totalAmount)
              ? Number(dataObj.totalAmount)
              : 0,
            totalAmountPayable: Number(dataObj?.netPayAmount)
              ? Number(dataObj?.netPayAmount)
              : 0,
            totalBalanceAmount: Number(dataObj?.netPayAmount)
              ? Number(dataObj?.netPayAmount)
              : 0,
            totalItemDiscountAmount: Number(dataObj.discAmount),
            totalItemTaxAmount: 0,
            totalOtherTaxAmount: 0,
            totalSchemeDiscountAmount: Number(dataObj?.schDisc),
            totalVatAmount: Number(dataObj.gstAmount),
            verified: true,
          };
          setOpenPost(true);
          setFinalData(postedObj);
          console.log("postedObj321", postedObj);
        }
      } else {
        warningAlert("Please Select Item First");
      }
    }
  };

  function getPositiveRounding(value) {
    const ceilValue = Math.ceil(value);
    return Number((ceilValue - value).toFixed(2));
  }

  function getNegativeRounding(value) {
    const floorValue = Math.floor(value);
    return Number((value - floorValue).toFixed(2));
  }

  React.useEffect(() => {
    if (totalCalculations !== null) {
      setPositiveRounding(getPositiveRounding(totalCalculations?.netAmountVal));
      setNegativeRounding(getNegativeRounding(totalCalculations?.netAmountVal));
    }
  }, [totalCalculations]);

  React.useEffect(() => {
    if (roundingValue !== null) {
      setValue("roundingAmount", roundingValue);
    }
  }, [roundingValue]);
  //StoreGRNTable Actions
  const renderActions = (row, index) => {
    return (
      <>
        <Checkbox
          control={control}
          disabled={row?.PendQty > 0 ? false : true}
          value={index}
          name={`selectOptions${row}`}
          sx={{ padding: 0.5 }}
          size="small"
          onChange={(e) => {
            handleSelect(e, row, index);
          }}
        />
      </>
    );
  };

  const handleSelect = (e, row, index) => {
    const isChecked = e?.target?.checked;

    let updatedRows = [...selectedRow];

    if (isChecked) {
      const updatedRow = {
        ...row,
        landedRate: row?.PendQty ? row.landedRate : 0,
        otherCharges: 0,
        Conversion: row?.Conversion ?? 0,
        FreeQty: 0,
        rectQty: 0,
        batchCode: row?.batchCode?.trim() || "",
        expiryDate: null,
        color: "",
      };
      updatedRows.push(updatedRow);
      calculateBeforeAfterTax(updatedRows);
      setSelectedRowDetails(row);
    } else {
      updatedRows = selectedRow.filter(
        (item) => item.ItemCode !== row.ItemCode,
      );
      setResetIndex((prev) => prev + 1);
      calculateBeforeAfterTax(updatedRows);
    }
    // setSelectedRow(updatedRows);
  };

  const calculateBeforeAfterTax = (dataArray) => {
    console.log("dataArray321", dataArray);
    let itemsArr = [...dataArray];
    let array = [];
    if (dataArray?.length > 0) {
      if (discountType === "After Disc & Tax") {
        for (let object of itemsArr) {
          let item = {};
          item.DOId = object.DOId;
          item.BatchesRequired = object.BatchesRequired;
          item.BatchExpiryDate = object.BatchExpiryDate;
          item.DONo = object.DONo;
          item.ItemId = object.ItemId;
          item.ItemCode = object.ItemCode;
          item.ItemName = object.ItemName;
          item.Rate = object.Rate;
          item.color = object.color;
          item.DOQty = object.DOQty;
          item.PendQty = object.PendQty;
          item.recQty = object.recQty;
          item.Amount = object.Amount;
          item.batchCode = object.batchCode;
          item.UnitRate = object.UnitRate;
          item.PurchaseUOM = object.PurchaseUOM;
          item.ItemForm = object.ItemForm;
          item.grnNumber = object.grnNumber;
          item.ItemMRP = object.ItemMRP;
          item.expiryDate = object.expiryDate ? object.expiryDate : "";
          item.DiscPer = object.DiscPer;
          let disc = Number(object.Amount) * Number(object.DiscPer);
          let discVal = Number(disc) / 100;
          let discountedAmount = Number(
            object.Amount - (discVal + Number(object?.SchemeAmount)),
          );
          item.DiscAmt = discVal.toFixed(2);
          item.VATPer = object.VATPer;
          let gst =
            ((Number(object.Amount) -
              (Number(discVal) + Number(object?.SchemeAmount))) *
              Number(object.VATPer)) /
            100;
          let netAmt = Number(discountedAmount) + Number(gst);
          let landedRate =
            netAmt / (Number(object.DOQty) + Number(object.FreeQty));
          item.landedRate = Number(landedRate).toFixed(2);
          item.VATAmt = gst.toFixed(2);
          item.Specification = object.Specification;
          item.MRP = object.MRP;
          item.Conversion = object.Conversion;
          item.Consignment = object.Consignment;
          // item.NetAmount = netAmt.toFixed(2);
          item.NetAmount = Number(
            Number(object.DOQty * object.Rate) -
              (Number(discVal) + Number(object?.SchemeAmount)) +
              Number(gst),
          )?.toFixed(2);
          item.FreeQty = object.FreeQty;
          item.otherCharges = object.otherCharges;
          item.GRNId = object.GRNId;
          item.GRNDetailId = object.GRNDetailId;
          item.DODetailId = object.DODetailId;
          item.SchemeDiscount = Number(object?.SchemeDiscount || 0);
          item.SchemeAmount = Number(object?.SchemeAmount || 0);
          array.push(item);
          setSelectedRow(array);
        }
      } else if (discountType === "Before Disc & Tax") {
        for (let object of itemsArr) {
          let item = {};
          item.DOId = object.DOId;
          item.BatchesRequired = object.BatchesRequired;
          item.BatchExpiryDate = object.BatchExpiryDate;
          item.DONo = object.DONo;
          item.ItemId = object.ItemId;
          item.ItemCode = object.ItemCode;
          item.ItemName = object.ItemName;
          item.Rate = object.Rate;
          item.color = object.color;
          item.DOQty = object.DOQty;
          item.PendQty = object.PendQty;
          item.recQty = object.recQty;
          item.Amount = object.Amount;
          item.batchCode = object.batchCode;
          item.UnitRate = object.UnitRate;
          item.PurchaseUOM = object.PurchaseUOM;
          item.ItemForm = object.ItemForm;
          item.grnNumber = object.grnNumber;
          item.ItemMRP = object.ItemMRP;
          item.DiscPer = object.DiscPer;
          item.Conversion = object.Conversion;
          item.Consignment = object.Consignment;
          item.expiryDate = object.expiryDate ? object.expiryDate : "";
          let disc = Number(object.Amount) * Number(object.DiscPer);
          let discVal = Number(disc) / 100;
          item.DiscAmt = discVal.toFixed(2);
          item.VATPer = object.VATPer;
          let gst = (Number(object.Amount) * Number(object.VATPer)) / 100;
          let netAmt = Number(object.Amount) + Number(gst);
          let landedRate =
            netAmt / (Number(object.DOQty) + Number(object.FreeQty));
          item.landedRate = Number(landedRate).toFixed(2);
          item.VATAmt = gst.toFixed(2);
          item.Specification = object.Specification;
          item.MRP = object.MRP;
          // item.NetAmount = netAmt.toFixed(2);
          item.NetAmount = Number(
            Number(object.DOQty * object.Rate) + Number(gst),
          )?.toFixed(2);
          item.FreeQty = object.FreeQty;
          item.otherCharges = object.otherCharges;
          item.GRNId = object.GRNId;
          item.GRNDetailId = object.GRNDetailId;
          item.DODetailId = object.DODetailId;
          item.SchemeDiscount = Number(object?.SchemeDiscount || 0);
          item.SchemeAmount = Number(object?.SchemeAmount || 0);
          array.push(item);
          setSelectedRow(array);
        }
      }
    } else {
      setSelectedRow([]);
    }
  };

  useEffect(() => {
    if (selectedRow?.length > 0) {
      calculateBeforeAfterTax(selectedRow);
    }
  }, [discountType]);

  useEffect(() => {
    if (location?.state?.menuId) {
      fetchUserActionsByMenuId(location?.state?.menuId)
        .then((response) => response.data)
        .then((res) => {
          setUserActions(res.result);
        });
    }
  }, []);

  useEffect(() => {
    setValue("supplierName", supplierValue);
    setValue("store", token.storeName);

    if (
      selectedGrn?.RoundingAmount !== 0 &&
      finalRounding === 0 &&
      totalCalculations !== null
    ) {
      setFinalRounding(selectedGrn?.RoundingAmount);
    }

    if (totalCalculations !== null) {
      setValue("netPayAmount", Number(totalCalculations.netAmount).toFixed(2));
      setValue("gstAmount", Number(totalCalculations.gstAmount).toFixed(2));
      setValue("totalAmount", Number(totalCalculations.totalAmount).toFixed(2));
      setValue(
        "discAmount",
        Number(totalCalculations.discountAmount).toFixed(2),
      );
      setValue(
        "schDisc",
        Number(totalCalculations?.schemeDiscAmount)?.toFixed(2),
      );
      setValue(
        "otherCharges",
        Number(totalCalculations.otherCharges).toFixed(2),
      );
    }
  }, [totalCalculations, supplierValue]);

  useEffect(() => {
    if (selectedRowDetails !== null) {
      getLastPurchaseDetails(selectedRowDetails.ItemId, storeId)
        .then((response) => response.data)
        .then((res) => {
          setValue("grnNumber", Number(res?.result?.GRNNumber));
          setValue("mrp", Number(res?.result?.MRP));
          setValue("freeQuantity", Number(res?.result?.FreeQty));
          setValue("lastPurDate", res?.result?.Date);
          setValue("batchNumber", res?.result?.BatchCode);
          setValue("lur", res?.result?.LUR);
          setValue("lastDiscAmt", Number(res?.result?.DiscAmount));
        });
    }
  }, [selectedRowDetails]);

  useEffect(() => {
    if (isGRNEdit === true) {
      setSupplierValue({
        id: dailyOrderDetailsData[0]?.SupplierId,
        value: dailyOrderDetailsData[0]?.SupplierId,
        label: dailyOrderDetailsData[0]?.SupplierName,
      });
      setValue("supplierName", {
        id: dailyOrderDetailsData[0]?.SupplierId,
        value: dailyOrderDetailsData[0]?.SupplierId,
        label: dailyOrderDetailsData[0]?.SupplierName,
      });
      setValue("invoiceNo", dailyOrderDetailsData[0]?.InvoiceNo);
      setValue("dcNumber", dailyOrderDetailsData[0]?.DCNumber);
      setValue("gateEntryNo", dailyOrderDetailsData[0]?.GateEntryNo);
      setValue("invoiceDate", new Date(dailyOrderDetailsData[0]?.InvoiceDate));
      setValue("dueDate", new Date(dailyOrderDetailsData[0]?.DueDate));

      let itemArr = [...selectedRow];
      itemArr = dailyOrderDetailsData.map((val) => ({
        ...val,
        landedRate: Number(val.PendQty) > 0 ? val.LandedNetRate : 0, // Apply your condition
        otherCharges: 0,
        Conversion: val?.Conversion,
        FreeQty: val?.["FreeQty"],
        rectQty: 0,
        batchCode: val?.batchCode,
        color: "",
        expiryDate: val?.BatchesRequired === true ? val?.BatchExpiryDate : "",
      }));
      calculateBeforeAfterTax(itemArr);
      // setSelectedRow(itemArr);
    }
  }, [isGRNEdit]);

  console.log("The data in the GRN details is :", selectedRow);
  console.log("dailyOrderDetailsData321", dailyOrderDetailsData);

  // Use filter to keep only the first occurrence of each ItemCode

  // React.useEffect(() => {
  //   if (finalRounding !== 0 && updateCount === 0) {
  //     if (selectedGrn?.RoundingAmount < 0) {
  //       setSelectedRounding("negative");
  //       let totals = structuredClone(totalCalculations);
  //       totals.netAmount = totals.netAmountVal - selectedGrn?.RoundingAmount;
  //       setTotalCalculations(totals);
  //     } else if (selectedGrn?.RoundingAmount > 0) {
  //       setSelectedRounding("positive");
  //       let totals = structuredClone(totalCalculations);
  //       totals.netAmount = totals.netAmountVal + selectedGrn?.RoundingAmount;
  //       setTotalCalculations(totals);
  //     }
  //     setUpdateCount(2);
  //   }
  // }, [finalRounding]);

  useEffect(() => {
    if (selectedRow?.length > 0) {
      let temp = [...selectedRow];
      let totalAmount = 0;
      let discAmount = 0;
      let schemeDiscAmount = 0;
      let gstAmount = 0;
      let netAmount = 0;
      let netAmountVal = 0;
      let roundingAmt = 0;
      let otherCharges = 0;
      let mrp = 0;
      let freeQty = 0;
      for (let obj of temp) {
        let tempObj = {};
        tempObj.totalAmount = totalAmount += Number(obj.Amount);
        tempObj.otherCharges = otherCharges += Number(obj.otherCharges);
        tempObj.discountAmount = discAmount += Number(obj.DiscAmt);
        tempObj.schemeDiscAmount = schemeDiscAmount += Number(obj.SchemeAmount);
        tempObj.gstAmount = gstAmount += Number(obj.VATAmt);
        tempObj.netAmount =
          Number((netAmount += Number(obj.NetAmount))) +
          Number(selectedGrn !== null ? selectedGrn?.RoundingAmount : 0);
        tempObj.netAmountVal = netAmountVal += Number(obj.NetAmount);
        tempObj.mrp = mrp += Number(obj.MRP);
        tempObj.batchCode = obj.batchCode;
        tempObj.expiryDate = obj.expiryDate;
        tempObj.FreeQty = freeQty += Number(obj.FreeQty);
        tempObj.roundingAmt = roundingAmt +=
          Number(obj.Amount) - Number(obj.DiscAmt) + Number(obj.VATAmt);
        setTotalCalculations(tempObj);
      }

      if (selectedGrn?.RoundingAmount < 0) {
        setSelectedRounding("negative");
      } else if (selectedGrn?.RoundingAmount > 0) {
        setSelectedRounding("positive");
      }
    }
  }, [selectedRow]);

  console.log("selectedGrn321", selectedGrn);

  console.log("totalCalculations", totalCalculations);

  console.log("positiveRounding", positiveRounding, negativeRounding);

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmitDataHandler)}>
          <div className="text-xl font-bold mt-12 text-center">GRN</div>
          <div className="space-y-2">
            <div className="lg:flex w-full gap-2">
              <fieldset className="border-2 border-gray-300 p-1 rounded-md w-full">
                <legend className="mx-2 px-2 font-semibold">GRN Details</legend>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <InputField
                      control={control}
                      name="store"
                      label="Store"
                      disabled={true}
                    />
                  </div>
                  <div>
                    <SearchDropdown
                      control={control}
                      searchIcon={true}
                      isDisabled={false}
                      isSearchable={true}
                      isClearable={true}
                      error={errors.supplierName}
                      name="supplierName"
                      placeholder="Supplier Name*"
                      dataArray={supplierList}
                      handleInputChange={handleChangeGetSupplierList}
                    />
                  </div>
                  <div>
                    <InputField
                      control={control}
                      name="invoiceNo"
                      label="Invoice No."
                      error={errors.invoiceNo}
                    />
                  </div>
                  <div>
                    <DatePickerFieldNew
                      control={control}
                      name="invoiceDate"
                      label="Invoice Date"
                      value={new Date()}
                      onChange={(newValue) => {
                        setValue("invoiceDate", newValue);
                      }}
                      disableFuture={true}
                      inputFormat="dd-MM-yyyy"
                    />
                  </div>
                  {/* <div>
                    <InputField
                      control={control}
                      name="dcNumber"
                      label="D.C. No."
                    />
                  </div> */}
                  {/* <div>
                    <DatePickerFieldNew
                      control={control}
                      name="dueDate"
                      label="Due Date"
                      value={new Date()}
                      onChange={(newValue) => {
                        setValue("dueDate", newValue);
                      }}
                      disableFuture={true}
                      inputFormat="dd-MM-yyyy"
                    />
                  </div> */}
                  <div>
                    <InputField
                      control={control}
                      name="gateEntryNo"
                      label="Get Entry No.*"
                      error={errors.gateEntryNo}
                    />
                  </div>
                  <div>
                    {userActions.map((obj) => (
                      <>
                        {!obj.isAction && obj.action === "Daily Orders" ? (
                          <>
                            <CommonButton
                              type="button"
                              className="bg-customBlue text-white"
                              label="Daily Orders"
                              onClick={() => {
                                OpenStoreGRNModal();
                              }}
                            />
                          </>
                        ) : null}
                      </>
                    ))}
                  </div>
                </div>
              </fieldset>
              <div className="w-full">
                <div className="flex space-x-2">
                  <div className="flex items-center">
                    <h4 className="font-bold">GRN Type: &nbsp;</h4>
                    <div className="mt-1.5">
                      <RadioField
                        control={control}
                        name="grnType"
                        dataArray={grnType}
                      />
                    </div>
                  </div>
                  <div className="flex items-center">
                    <h4 className="font-bold">Payment Type: &nbsp;</h4>
                    <div className="mt-1.5">
                      <RadioField
                        control={control}
                        name="paymentType"
                        dataArray={paymentType}
                      />
                    </div>
                  </div>
                </div>
                <fieldset className="border-2 border-gray-300 p-1 rounded-md">
                  <legend className="mx-2 px-2 font-bold text-base">
                    Last Purchase Details
                  </legend>
                  <div className="grid grid-cols-4 gap-2">
                    <div>
                      <InputField
                        control={control}
                        name="lur"
                        label="L.U.R."
                        disabled={true}
                      />
                    </div>
                    <div>
                      <InputField
                        control={control}
                        name="ptr"
                        label="P.T.R."
                        disabled={true}
                      />
                    </div>
                    <div>
                      <DatePickerFieldNew
                        control={control}
                        name="lastPurDate"
                        disabled
                        label="Date"
                        // value={new Date()}
                        onChange={(newValue) => {
                          setValue("date", newValue);
                        }}
                        disableFuture={true}
                        inputFormat="dd-MM-yyyy"
                      />
                    </div>
                    <div>
                      <InputField
                        control={control}
                        name="mrp"
                        label="M.R.P."
                        disabled={true}
                      />
                    </div>
                    <div>
                      <InputField
                        control={control}
                        name="lastDiscAmt"
                        label="Disc"
                        disabled={true}
                      />
                    </div>
                    <div>
                      <InputField
                        control={control}
                        name="batchNumber"
                        label="Batch"
                        disabled={true}
                      />
                    </div>
                    <div>
                      <InputField
                        control={control}
                        name="freeQuantity"
                        label="Free Qty"
                        disabled={true}
                      />
                    </div>
                    <div>
                      {userActions.map((obj) => (
                        <>
                          {!obj.isAction && obj.action === "GRN List" ? (
                            <>
                              <div className="flex justify-end">
                                <CommonButton
                                  type="button"
                                  className="bg-customBlue text-white"
                                  label="GRN List"
                                  onClick={() => {
                                    setDailyOrderDetailsData([]);
                                    setOpenGRNListModal(true);
                                    setGRNListPrivilege(obj);
                                  }}
                                />
                              </div>
                            </>
                          ) : null}
                        </>
                      ))}
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            {getGrnType === "dailyOrders" ? (
              <div>
                {isGRNEdit === false && (
                  <div className="w-full grid">
                    <h4 className="font-bold ">Daily Order Details</h4>
                    {dailyOrderDetailsData.length > 0 ? (
                      <>
                        <CommonDynamicTable
                          dataResult={dailyOrderDetailsData}
                          actionsRequired={true}
                          renderActions={renderActions}
                          highlightRow={false}
                          tableClass={"rounded md:h-52 2xl:h-52 border"}
                          removeHeaders={[
                            "DOId",
                            "ItemId",
                            "batchCode",
                            "BatchesRequired",
                            "Consignmen",
                            "DODetailId",
                            "otherCharges",
                            "rectQty",
                            "color",
                            "landedRate",
                            "requiredBatchNumber",
                            "GRNId",
                            "GRNNumber",
                            "StoreId",
                            "StoreName",
                            "SupplierId",
                            "SupplierName",
                            "InvoiceNo",
                            "InvoiceDate",
                            "DCNumber",
                            "DCDate",
                            "DueDate",
                            "GateEntryNo",
                            "GRNDetailId",
                            "BatchCode",
                            "BatchExpiryDate",
                            "POId",
                            "DCId",
                            "POQty",
                            "DCQty",
                            "RectQty",
                            "AcceptQty",
                            "PurchaseRate",
                            "LandedNetRate",
                            "UnitPurchaseRate",
                            "OctroiPer",
                            "OctroiAmt",
                            "TotalReturnQty",
                            "TotalUsedQty",
                          ]}
                        />
                      </>
                    ) : (
                      <h1 className="text-center font-semibold my-5 2xl:my-0 2xl:py-14 text-gray-600 border rounded mt-2">
                        No Records Found
                        <span className="tracking-widest animate-pulse">
                          ...
                        </span>
                      </h1>
                    )}
                  </div>
                )}
                <div className="w-full grid">
                  <l className="font-bold ">Item Details</l>
                  {selectedRow.length > 0 ? (
                    <ItemDetailsTable
                      data={selectedRow}
                      setData={setSelectedRow}
                      setTotalCalculations={setTotalCalculations}
                      discountType={discountType}
                      totalCalculations={totalCalculations}
                      isBatchRequired={isBatchRequired}
                      setOpenPost={setOpenPost}
                      setIsBatchRequired={setIsBatchRequired}
                      resetIndex={resetIndex}
                      dailyOrderDetailsData={dailyOrderDetailsData}
                      dataComingFrom={dataComingFrom}
                      calculateBeforeAfterTax={calculateBeforeAfterTax}
                    />
                  ) : (
                    <h1 className="text-center font-semibold my-5 2xl:my-0 2xl:py-14 text-gray-600 border rounded mt-2">
                      No Records Found
                      <span className="tracking-widest animate-pulse">...</span>
                    </h1>
                  )}
                </div>
              </div>
            ) : (
              <div className="w-full">
                <label className="font-bold ">Delivery Challan Details</label>
                {/* <StoreGRNTable data={data} /> */}
              </div>
            )}
            <div className="grid grid-cols-8 gap-2">
              <div className="row-span-2 col-span-2 items-center">
                <div>
                  <RadioField
                    control={control}
                    name="discTax"
                    dataArray={discTaxObj}
                  />
                </div>
                <div className="flex gap-2 items-center">
                  {/* <input
                    disabled
                    {...register("roundingAmount")}
                    name="roundingAmount"
                    className="border border-gray-400 rounded h-9 p-1 text-center"
                    placeholder="Rounding Amount"
                  /> */}
                  {/* <RadioField
                    control={control}
                    name={"roundingType"}
                    label={""}
                    dataArray={roundingTypes}
                  /> */}

                  <div className="flex gap-2 items-center">
                    {positiveRounding > 0 && (
                      <div
                        onClick={() => {
                          if (selectedRounding === "positive") {
                            setSelectedRounding("");
                            setFinalRounding(0);

                            let totals = structuredClone(totalCalculations);

                            totals.netAmount = totals.netAmountVal;
                            setTotalCalculations(totals);
                          } else {
                            setSelectedRounding("positive");
                            let totals = structuredClone(totalCalculations);
                            totals.netAmount =
                              totals.netAmountVal + positiveRounding;

                            setFinalRounding(positiveRounding);

                            setTotalCalculations(totals);
                          }
                        }}
                        className={`${
                          selectedRounding === "positive"
                            ? `bg-customBlue text-white`
                            : ``
                        } px-4 rounded cursor-pointer flex justify-center items-center text-center h-8 border border-gray-400`}
                      >
                        +{positiveRounding}
                      </div>
                    )}
                    {negativeRounding > 0 && (
                      <div
                        onClick={() => {
                          if (selectedRounding === "negative") {
                            console.log(
                              "rrrrrrrrrrrrrrrrrrrrrrrrr",

                              positiveRounding,
                            );
                            setSelectedRounding("");
                            setFinalRounding(0);

                            let totals = structuredClone(totalCalculations);

                            totals.netAmount = totals.netAmountVal;
                            setTotalCalculations(totals);
                          } else {
                            setSelectedRounding("negative");
                            let totals = structuredClone(totalCalculations);

                            totals.netAmount =
                              totals.netAmountVal - negativeRounding;

                            setFinalRounding("-" + negativeRounding);

                            setTotalCalculations(totals);
                          }
                        }}
                        className={`${
                          selectedRounding === "negative"
                            ? `bg-customBlue text-white`
                            : ``
                        } px-4 rounded cursor-pointer flex justify-center items-center text-center h-8 border border-gray-400`}
                      >
                        -{negativeRounding}
                      </div>
                    )}
                  </div>

                  <div className="flex gap-2 items-center">
                    {/* <CommonButton
                      label={
                        <AddCircleRounded
                          sx={{
                            color: "#1E3A8A",
                          }}
                        />
                      }
                      onClick={() => {
                        let totalAmounts = structuredClone(totalCalculations);
                        let roundingAmountValue = Number(
                          "0." +
                            Number(totalAmounts?.netAmountVal)
                              ?.toString()
                              ?.split(".")?.[1]
                        );
                        setValue("roundingAmount", roundingAmountValue);
                        let totals = structuredClone(totalCalculations);
                        totals.netAmount =
                          totals.netAmount + roundingAmountValue;

                        setTotalCalculations(totals);
                      }}
                      // className={}
                      type={"button"}
                    /> */}
                    {/* <CommonButton
                      label={
                        <RemoveCircleOutlineRounded
                          sx={{
                            color: "red",
                          }}
                        />
                      }
                      onClick={() => {
                        let totalAmounts = structuredClone(totalCalculations);
                        let roundingAmountValue = Number(
                          "0." +
                            Number(totalAmounts?.netAmountVal)
                              ?.toString()
                              ?.split(".")?.[1]
                        );
                        console.log(
                          "totalstotalstotalstotals",
                          totalAmounts?.netAmountVal,
                          roundingAmountValue
                        );

                        setValue("roundingAmount", "-" + roundingAmountValue);
                        let totals = structuredClone(totalCalculations);
                        totals.netAmount =
                          totals.netAmount - roundingAmountValue;
                        setTotalCalculations(totals);
                      }}
                      // className={}
                      type={"button"}
                    /> */}
                  </div>
                </div>
              </div>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="discAmount"
                  label="C.Disc Amt"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="schDisc"
                  label="Sch.Disc"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="octroiAmt"
                  label="Octroi Amt"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="netPayAmount"
                  label="Net Pay Amount"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "blue",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="otherCharges"
                  label="Other Charges"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="gstAmount"
                  label="GST Amount"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>

              <div>
                <InputField
                  control={control}
                  name="creditNote"
                  label="Credit Note"
                />
              </div>
              <fieldset disabled>
                <InputField
                  control={control}
                  name="totalAmount"
                  label="Total Amount"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </fieldset>

              <div className="col-span-2">
                <InputField
                  control={control}
                  name="received"
                  label="Received"
                  error={errors.received}
                />
              </div>

              <div className="col-span-2">
                <InputField control={control} name="remarks" label="Remarks" />
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-2">
            {userActions.map((obj) => (
              <>
                {!obj.isAction && obj.action === "Create" ? (
                  <>
                    <CommonButton
                      type="button"
                      className="border border-customRed text-customRed"
                      label="Reset"
                      onClick={() => {
                        setFinalData(null);
                        setSelectedRow([]);
                        setSelectedRowDetails([]);
                        setTotalCalculations(null);
                        setDailyOrderDetailsData([]);
                        setSupplierList([]);
                        setSupplierValue(null);
                        setDailyOrderObj();
                        setIsBatchRequired(true);
                        setOpenBackdrop(false);
                        setIsGRNEdit(false);
                        setValue("totalAmt", "0");
                        setValue("discAmt", "0");
                        setValue("gstAmt", "0");
                        setValue("roundingAmt", "0");
                        setValue("netPaybaleAmt", "0");
                        setValue("supplierName", null);
                        reset(defaultValues);
                        setSelectedGrn(null);
                      }}
                    />

                    <CommonButton
                      type="submit"
                      className="bg-customGreen text-white"
                      label={`${isGRNEdit === true ? "Update" : "Save"}`}
                      onClick={() => {
                        setPrivilege(obj.action);
                      }}
                    />
                  </>
                ) : null}
              </>
            ))}
          </div>
        </form>
      </FormProvider>
      <CommonBackDrop openBackdrop={openBackdrop} />
      {openGrnModal && (
        <StoreGRNModal
          openGrnModal={openGrnModal}
          setOpenGrnModal={setOpenGrnModal}
          setSupplierValue={setSupplierValue}
          setDailyOrderDetailsData={setDailyOrderDetailsData}
          dailyOrderDetailsData={dailyOrderDetailsData}
          setDailyOrderObj={setDailyOrderObj}
          setPrivilege={setPrivilege}
          privilege={privilege}
          userActions={userActions}
          setDataComingFrom={setDataComingFrom}
          setSelectedGrn={setSelectedGrn}
          setIsGRNEdit={setIsGRNEdit}
          setSelectedRow={setSelectedRow}
        />
      )}
      {openGRNListModal && (
        <GRNListModal
          openGRNListModal={openGRNListModal}
          setOpenGRNListModal={setOpenGRNListModal}
          GRNListPrivilege={GRNListPrivilege}
          setDailyOrderDetailsData={setDailyOrderDetailsData}
          setIsGRNEdit={setIsGRNEdit}
          setDataComingFrom={setDataComingFrom}
          setRoundingValue={setRoundingValue}
          setSelectedGrn={setSelectedGrn}
          setOpenBackdrop={setOpenBackdrop}
          setTotalCalculations={setTotalCalculations}
        />
      )}
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={handleClosePost}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure want to ${
          isGRNEdit === true ? "update" : "add"
        } this record ?`}
        confirmationButtonMsg={`${isGRNEdit === true ? "Update" : "Add"}`}
      />
    </>
  );
};

export default StroeGRN;
